<template>
  <div v-if="category" class="tag-section">
    <div class="category-wrapper">
      <h2 class="section-header">
        {{ category.category.name }}
      </h2>
      <ContextMenu
        v-if="!isDefault"
        tag-menu
        :item="category"
        @delete="showDeleteCategoryPopup"
        @inputValue="changeCategoryName"
      />
    </div>
    <div class="section-tags">
      <draggable
        v-if="category.tags.length > 0 && category.tags[0].id !== 0"
        v-model="category.tags"
        class="draggable"
        @end="onTagDragEnd($event)"
      >
        <TagItem
          v-for="(tag, index) in category.tags"
          :key="index"
          :tag="tag"
          :is-default="isDefault"
          @delete="showDeleteTagPopup"
          @changeTag="changeTag"
        />
      </draggable>
      <div v-if="newTagInput" class="add-tag">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="addTag"
        >
          <g clip-path="url(#clip0_19972_116898)">
            <path
              d="M22.4348 0H1.56522C1.1501 0 0.751977 0.164906 0.458441 0.458441C0.164906 0.751977 0 1.1501 0 1.56522V22.4348C0 22.8499 0.164906 23.248 0.458441 23.5416C0.751977 23.8351 1.1501 24 1.56522 24H22.4348C22.8499 24 23.248 23.8351 23.5416 23.5416C23.8351 23.248 24 22.8499 24 22.4348V1.56522C24 1.1501 23.8351 0.751977 23.5416 0.458441C23.248 0.164906 22.8499 0 22.4348 0ZM22.9565 22.4348C22.9565 22.5732 22.9016 22.7059 22.8037 22.8037C22.7059 22.9016 22.5732 22.9565 22.4348 22.9565H1.56522C1.42684 22.9565 1.29414 22.9016 1.19629 22.8037C1.09845 22.7059 1.04348 22.5732 1.04348 22.4348V1.56522C1.04348 1.42684 1.09845 1.29414 1.19629 1.19629C1.29414 1.09845 1.42684 1.04348 1.56522 1.04348H22.4348C22.5732 1.04348 22.7059 1.09845 22.8037 1.19629C22.9016 1.29414 22.9565 1.42684 22.9565 1.56522V22.4348ZM17.7391 12C17.7391 12.1384 17.6842 12.2711 17.5863 12.3689C17.4885 12.4668 17.3558 12.5217 17.2174 12.5217H12.5217V17.2174C12.5217 17.3558 12.4668 17.4885 12.3689 17.5863C12.2711 17.6842 12.1384 17.7391 12 17.7391C11.8616 17.7391 11.7289 17.6842 11.6311 17.5863C11.5332 17.4885 11.4783 17.3558 11.4783 17.2174V12.5217H6.78261C6.64423 12.5217 6.51153 12.4668 6.41368 12.3689C6.31584 12.2711 6.26087 12.1384 6.26087 12C6.26087 11.8616 6.31584 11.7289 6.41368 11.6311C6.51153 11.5332 6.64423 11.4783 6.78261 11.4783H11.4783V6.78261C11.4783 6.64423 11.5332 6.51153 11.6311 6.41368C11.7289 6.31584 11.8616 6.26087 12 6.26087C12.1384 6.26087 12.2711 6.31584 12.3689 6.41368C12.4668 6.51153 12.5217 6.64423 12.5217 6.78261V11.4783H17.2174C17.3558 11.4783 17.4885 11.5332 17.5863 11.6311C17.6842 11.7289 17.7391 11.8616 17.7391 12Z"
              fill="#373C44"
            />
          </g>
          <defs>
            <clipPath id="clip0_19972_116898">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <CustomInput
          id="input_invite_mail"
          ref="newTagNameInput"
          v-model="newTagName"
          placeholder="Enter tag name"
          style="max-width: 300px;"
          @input="addTag"
          @value="newTagName = $event"
        />
        <svg
          class="close-icon"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="closeNewTagInput"
        >-->
          <path
            d="M10 0.499969C4.47 0.499969 0 4.96997 0 10.5C0 16.03 4.47 20.5 10 20.5C15.53 20.5 20 16.03 20 10.5C20 4.96997 15.53 0.499969 10 0.499969ZM15 14.09L13.59 15.5L10 11.91L6.41 15.5L5 14.09L8.59 10.5L5 6.90997L6.41 5.49997L10 9.08997L13.59 5.49997L15 6.90997L11.41 10.5L15 14.09Z"
            fill="#D7DCE6"
          />
          -->
        </svg>
      </div>
      <div v-else-if="!isDefault || category.category.name === 'Issues'" class="add-tag" @click="showTagInput">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_19972_116898)">
            <path
              d="M22.4348 0H1.56522C1.1501 0 0.751977 0.164906 0.458441 0.458441C0.164906 0.751977 0 1.1501 0 1.56522V22.4348C0 22.8499 0.164906 23.248 0.458441 23.5416C0.751977 23.8351 1.1501 24 1.56522 24H22.4348C22.8499 24 23.248 23.8351 23.5416 23.5416C23.8351 23.248 24 22.8499 24 22.4348V1.56522C24 1.1501 23.8351 0.751977 23.5416 0.458441C23.248 0.164906 22.8499 0 22.4348 0ZM22.9565 22.4348C22.9565 22.5732 22.9016 22.7059 22.8037 22.8037C22.7059 22.9016 22.5732 22.9565 22.4348 22.9565H1.56522C1.42684 22.9565 1.29414 22.9016 1.19629 22.8037C1.09845 22.7059 1.04348 22.5732 1.04348 22.4348V1.56522C1.04348 1.42684 1.09845 1.29414 1.19629 1.19629C1.29414 1.09845 1.42684 1.04348 1.56522 1.04348H22.4348C22.5732 1.04348 22.7059 1.09845 22.8037 1.19629C22.9016 1.29414 22.9565 1.42684 22.9565 1.56522V22.4348ZM17.7391 12C17.7391 12.1384 17.6842 12.2711 17.5863 12.3689C17.4885 12.4668 17.3558 12.5217 17.2174 12.5217H12.5217V17.2174C12.5217 17.3558 12.4668 17.4885 12.3689 17.5863C12.2711 17.6842 12.1384 17.7391 12 17.7391C11.8616 17.7391 11.7289 17.6842 11.6311 17.5863C11.5332 17.4885 11.4783 17.3558 11.4783 17.2174V12.5217H6.78261C6.64423 12.5217 6.51153 12.4668 6.41368 12.3689C6.31584 12.2711 6.26087 12.1384 6.26087 12C6.26087 11.8616 6.31584 11.7289 6.41368 11.6311C6.51153 11.5332 6.64423 11.4783 6.78261 11.4783H11.4783V6.78261C11.4783 6.64423 11.5332 6.51153 11.6311 6.41368C11.7289 6.31584 11.8616 6.26087 12 6.26087C12.1384 6.26087 12.2711 6.31584 12.3689 6.41368C12.4668 6.51153 12.5217 6.64423 12.5217 6.78261V11.4783H17.2174C17.3558 11.4783 17.4885 11.5332 17.5863 11.6311C17.6842 11.7289 17.7391 11.8616 17.7391 12Z"
              fill="#373C44"
            />
          </g>
          <defs>
            <clipPath id="clip0_19972_116898">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <h2 class="section-header">
          Add tag
        </h2>
      </div>
    </div>
    <CommonDialog ref="commonDeleteCategoryWarningDialog">
      <h2 class="dialog-message-title">
        Deleting category
      </h2>
      <p class="dialog-message-description" style="display:block;">
        Before you can delete a category, you need to remove
        all tags from it
      </p>
    </CommonDialog>
    <InfoDialog
      ref="infoDeleteTagDialog"
      :title="infoDialogData.dialogTitle"
      :text="infoDialogData.dialogText"
      :confirm-btn-text="infoDialogData.confirmBtnText"
      :cancel-btn-text="infoDialogData.cancelBtnText"
      @onConfirm="deleteTag"
    />
    <InfoDialog
      ref="infoDeleteCategoryDialog"
      :title="infoDialogData.dialogTitle"
      :text="infoDialogData.dialogText"
      :confirm-btn-text="infoDialogData.confirmBtnText"
      :cancel-btn-text="infoDialogData.cancelBtnText"
      @onConfirm="deleteCategory"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';
import CustomInput from '@/components/inputs/CustomInput.vue';
import {createCategoryDeleteDialog, createTagDeleteDialog} from '@/constants/infoDialogData';
import InfoDialog from '@/components/popups/InfoDialog.vue';
import TagItem from '@/components/cases/case-messages/tagging-common/TagItem.vue';
import ContextMenu from '@/components/popups/ContextMenu.vue';
import messagesTagging from '@/mixins/messagesTagging';
import CommonDialog from '@/components/popups/CommonDialog.vue';

export default {
  name: 'TaggingCategory',
  components: {
    CommonDialog,
    ContextMenu,
    TagItem,
    InfoDialog,
    CustomInput,
    draggable,
  },
  emits: ['changeTag', 'changeTagOrder', 'addTag', 'deleteTag', 'deleteCategory', 'changeCategory'],
  mixins: [capitalizeFirstLetter, messagesTagging],
  props: {
    category: {
      type: Object,
      required: true,
    },
    isDefault: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      newTagName: '',
      newTagInput: false,
      infoDialogData: {
        dialogTitle: '',
        dialogText: '',
        confirmBtnText: '',
        cancelBtnText: '',
      },
    };
  },
  methods: {
    changeTag(event) {
      this.$emit('changeTag', event);
    },
    onTagDragEnd(event) {
      if (event.newIndex !== event.oldIndex) {
        this.$emit('changeTagOrder', {
          id: event.item._underlying_vm_.id,
          categoryId: this.category.category.id,
          orderIndex: event.newIndex + 1,
        });
      }
    },
    showTagInput() {
      this.newTagInput = !this.newTagInput;
    },
    closeNewTagInput() {
      this.newTagInput = false;
      this.newTagName = '';
    },
    addTag() {
      const refTagNameInput = this.$refs.newTagNameInput.getInput();
      if (this.newTagInput && this.newTagInput.length > 0) {
        this.$emit('addTag', {categoryId: this.category.category.id, newTagName: this.newTagName});
      } else if (refTagNameInput && refTagNameInput.length > 0) {
        this.$emit('addTag', {categoryId: this.category.category.id, newTagName: refTagNameInput});
      }
      this.closeNewTagInput();
    },
    deleteTag(tagId) {
      this.$emit('deleteTag', tagId);
    },
    changeCategoryName(newCatName) {
      this.$emit('changeCategory', {categoryId: this.category.category.id, categoryName: newCatName});
    },
    async deleteCategory(categoryId) {
      this.$emit('deleteCategory', categoryId);
    },

    showDeleteTagPopup(tag) {
      this.infoDialogData = createTagDeleteDialog(tag.tag);
      this.$refs.infoDeleteTagDialog.openPopup(tag.id);
    },
    showDeleteCategoryPopup(category) {
      if (category.tags.length > 1 || category.tags[0].id !== 0) {
        this.$refs.commonDeleteCategoryWarningDialog.openPopups();
      } else {
        this.infoDialogData = createCategoryDeleteDialog(category.category.name);
        this.$refs.infoDeleteCategoryDialog.openPopup(category.category.id);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.tag-section {
  padding: 10px 10px 0 0;
  border-top: 1px solid var(--border-color);
  max-width: 700px;
  width: 100%;

  .category-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    svg {
      cursor: grab;
    }

    .section-header {
      font-size: 16px;
      font-weight: 700;
      line-height: 19.36px;
      text-align: left;
      color: var(--accent-color);
    }
  }

  .section-tags {
    padding-bottom: 15px;
    border-bottom: 1px solid var(--border-color);

    .draggable {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .add-tag {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      margin: 0 0 0 35px;

      .section-header {
        font-size: 14px;
        font-weight: 400;
        line-height: 16.94px;
        text-align: left;
        color: var(--secondary-black-color);
      }
    }
  }
}
</style>
